import { type FWorkflowStepDefinitionFragment } from '@dashboard/generated/wp/platform';

const TYPES = [
  //
  'sendEmailTemplateMessage',
  'sendMarkdownEmailMessage',
  'sleep',
] as const;

export function getWorkflowStepDefinitionType(step: FWorkflowStepDefinitionFragment) {
  const res = TYPES.find((t) => step[t]);
  return res ? res : null;
}
